<template>
  <div 
    @click.stop="displayEvent(numYear, 'event'+numYear)"
    v-click-outside="closeEvent"
    class="w-max shadow-lg rounded-xl transition ease-in-out duration-300 cursor-pointer"
    :id="'event'+numYear"
  >
    <div class="flex items-center p-2 cursor-pointer">
      <div class="flex items-center">
        <div :class="textColor+' '+backgroundColor+' p-2 rounded-full flex items-center justify-center'">
          <icon
            :name="icon"
            class="w-4 h-4 font-normal"
          />
        </div>
        <div class="text-base ml-2.5"> 
          {{ year.event.type }}
        </div>
      </div>
      <div class="flex-grow" />
      <div 
        v-if="!isDisplayedEvent"
        :class="textColor+' ml-2.5'"
      >
        <icon name="chevron-down" />
      </div>
      <div
        v-if="isDisplayedEvent" 
        :class="textColor+' ml-2.5'"
      >
        <icon name="chevron-right" />
      </div>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        class="px-4 pb-3 text-sm text-gray-600 w-max"
        v-if="isDisplayedEvent"
      >
        <div class="pb-1 flex space-x-1">
          <div v-if="year.event.debut">
            {{ ('0' + new Date(year.event.debut).getDate()).slice(-2) }}/{{ ('0' + (new Date(year.event.debut).getMonth()+1)).slice(-2) }}/{{ new Date(year.event.debut).getFullYear() }}
          </div>
          <div v-if="year.event.debut && year.event.fin">
            -
          </div> 
          <div
            v-if="year.event.fin"
            class="flex space-x-1"
          >
            <p v-if="year.event.type === 'RQTH'">
              Fin de validité le
            </p>
            <p>{{ ('0' + new Date(year.event.fin).getDate()).slice(-2) }}/{{ ('0' + (new Date(year.event.fin).getMonth()+1)).slice(-2) }}/{{ new Date(year.event.fin).getFullYear() }}</p>
          </div>
        </div>
        <p class="italic">
          {{ year.event.intitule }}
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from './../Icon';
import ClickOutside from 'vue-click-outside';

export default {
  components:{
    Icon,
  },

  props:{
    year: Object,
    numYear: Number,
    icon: String,

    backgroundColor:String,
    textColor:String,
        
    isDisplayedEvent:Boolean,
  },

  methods:{
    displayEvent(){
      if(!this.isDisplayedEvent){
        this.$emit('displayEvent');
      }else{
        this.closeEvent();
      }
    },
    closeEvent(){
      if(this.isDisplayedEvent){
        this.$emit('closeEvent');
      }
    }
  },
  directives:{
    ClickOutside
  }
};
</script>